import type { FunctionComponentWithRef } from "react";

import { Icon, StyledButton } from "./styles";

type Props = {
  className?: string;
  onClick?: () => void;
};

export const ArticleCommentsIcon: FunctionComponentWithRef<Props, HTMLButtonElement> = ({
  className,
  onClick,
  ref: forwardReference,
}) => (
  <StyledButton className={className} onClick={onClick} ref={forwardReference}>
    <Icon />
  </StyledButton>
);

ArticleCommentsIcon.displayName = "ArticleCommentsIcon";
